import { createApp } from "vue"
import App from "./App.vue"
import pinia from "./store"
import i18n from "./i18n"
import router from "./router"
import { VueMaskDirective } from "v-mask"
import "@/assets/styles/main.scss"
import { vImageSrc, vVideoSrc } from "@/shared/directives/mediaDirectives.ts"
import { vCan } from "@/directives/can"
// import * as Sentry from "@sentry/vue";

const app = createApp(App);

// Sentry.init({
// 	app,
// 	dsn: "https://df468f94943db18ae2af1be9613f049e@45.14.135.41:9090/6",
// 	integrations: [
// 		Sentry.browserTracingIntegration({ router }),
// 		Sentry.replayIntegration(),
// 	],
//
// 	// Set tracesSampleRate to 1.0 to capture 100%
// 	// of transactions for performance monitoring.
// 	// We recommend adjusting this value in production
// 	tracesSampleRate: 1.0,
//
// 	// Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
// 	tracePropagationTargets: ["localhost", import.meta.env.BASE_URL],
//
// 	// Capture Replay for 10% of all sessions,
// 	// plus for 100% of sessions with an error
// 	replaysSessionSampleRate: 0.1,
// 	replaysOnErrorSampleRate: 1.0,
// });

app.use(pinia);
app.use(i18n);
app.use(router);
app.directive("mask", VueMaskDirective);
app.directive("image-src", vImageSrc)
app.directive("video-src", vVideoSrc)
app.directive("can", vCan)
app.mount("#app");
